import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { SxProps } from "@mui/material";
import * as React from "react";

import { useNavigation } from "@/providers";
import { RobotoButton } from "@/shared/components";
import {
  ActionReference,
  InvocationRecord,
  isDataSourceSpecified,
} from "@/shared/domain/actions";
import { OrgRecord } from "@/shared/domain/orgs";

interface CloneInvocationButtonProps {
  invocation?: InvocationRecord;
  org: OrgRecord | null;
  sx?: SxProps;
}

export default function CloneInvocationButton({
  invocation,
  org,
  sx,
}: CloneInvocationButtonProps) {
  const { goto } = useNavigation();
  const styles = React.useMemo(() => {
    const base = {
      mr: 1,
    };
    if (!sx) {
      return base;
    }

    return {
      ...base,
      ...sx,
    };
  }, [sx]);

  let datasetId: string | undefined = undefined;
  const dataSource = invocation?.data_source;
  if (dataSource && isDataSourceSpecified(dataSource)) {
    datasetId = dataSource.data_source_id;
  }

  return (
    <>
      <RobotoButton
        eventName={"InvocationCloned"}
        eventProperties={{
          id: invocation?.invocation_id || "",
        }}
        onClick={() => {
          const actionRef = {
            name: invocation?.provenance.action.name,
            digest: invocation?.provenance.action.digest,
            owner:
              org?.org_id !== invocation?.provenance.action.org_id
                ? invocation?.provenance.action.org_id
                : undefined,
          } as ActionReference;

          goto.invokeAction({
            action: actionRef,
            datasetId: datasetId,
            baseInvocation: invocation?.invocation_id,
          });
        }}
        startIcon={<ContentCopyIcon />}
        sx={styles}
        variant="outlined"
        size="small"
        color="primary"
      >
        Clone
      </RobotoButton>
    </>
  );
}
